import classNames from "classnames";
import { IoMdMan, IoMdWoman } from "react-icons/io";

import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button, ButtonType } from "@/components/common/button";

const icons: Record<string, any> = {
  male: <IoMdMan className="w-full h-full min-w-[80px]" />,
  female: <IoMdWoman className="w-full h-full min-w-[80px]" />,
};

type Option = {
  label: string;
  value: string;
};

const SelectSexQuestion = ({
  question,
  questionValue,
  setQuestionAnswer,
}: QuizQuestionProps<string>) => {
  const currentIcons = icons;
  const currentValue = "";

  const options = question?.attributes?.options as Option[] | undefined;

  if (!options?.length) {
    return <></>;
  }

  return (
    <div>
      <div className="flex gap-2.5 sm:gap-3 lg:gap-4">
        {options.map(({ label, value }) => (
          <div
            key={label}
            className={classNames("group interactive-card", {
              "!border-purple-2": questionValue === value,
            })}
            onClick={() => setQuestionAnswer(value)}
          >
            <div
              className={classNames(
                "mb-2 sm:mb-3 lg:mb-4 h-20 sm:h-28 text-dark-purple group-hover:text-purple-2",
                {
                  "text-purple-2": questionValue === value,
                }
              )}
            >
              {currentIcons[value]}
            </div>
            <p
              className={classNames(
                "text-base sm:text-lg lg:text-xl text-charcoal-gray font-bold transition ease-in duration-300 group-hover:text-purple-2",
                {
                  "text-purple-2": currentValue === value,
                }
              )}
            >
              {label}
            </p>
          </div>
        ))}
      </div>

      <Button type={ButtonType.NEXT} showOnlyBackButton />
    </div>
  );
};

export { SelectSexQuestion };
